import { kHTMLCore } from "../../../Admin/kReusableCoreTS/kHTMLCore";

/** Shared opening fragment for product buttons; callers retain their distinct busy/off policies. */
export class AppButton {
    /**
     * DOCUMENTED EXCEPTION: string fragment using the original shared escapers in their original order.
     * ERROR-PROPAGATION-JUSTIFIED: facade guards and catches retain diagnostic/fault ownership.
     * No closing angle bracket: each caller appends its own disabled state and label.
     */
    public static Open = (Id: string, Kind: string): string => {
        return "<button type=\"button\" class=\"btn " + kHTMLCore.EscapeAttr(Kind) + "\" id=\""
            + kHTMLCore.EscapeAttr(Id) + "\"";
    };
}
